export const lockScroll = () => {
  recordUnlockedState();

  setStyles({
    overflow: "hidden",
    paddingRight: getLockedPaddingRightStyle(),
  });
};

export const unlockScroll = () => {
  setStyles({
    overflow: unlockedStyles.overflow,
    paddingRight: unlockedStyles.paddingRight,
  });
};

/**
 * We want to pad the right-hand side of the page by the scrollbar width
 * to avoid layout shifts when locking the scroll. We'll also include any
 * existing padding.
 */
const getLockedPaddingRightStyle = () =>
  `${(
    getScrollbarWidth() +
    parseFloat(window.getComputedStyle(document.documentElement).paddingRight)
  ).toString()}px`;

const getScrollbarWidth = () =>
  window.innerWidth - document.documentElement.clientWidth;

const recordUnlockedState = () => {
  unlockedStyles = getStyles();

  document.documentElement.style.setProperty(
    "--bloom-unlocked-scrollbar-width",
    `${getScrollbarWidth().toString()}px`,
  );
};

const getStyles = () => ({
  overflow: document.documentElement.style.overflow,
  paddingRight: document.documentElement.style.paddingRight,
});

const setStyles = ({
  overflow,
  paddingRight,
}: {
  overflow: string;
  paddingRight: string;
}) => {
  document.documentElement.style.overflow = overflow;
  document.documentElement.style.paddingRight = paddingRight;
};

let unlockedStyles = getStyles();
